<template>
    <div class="books_wrapper w">
        <div class="books_title">
            <div class="books_title_name">
                <index-title-icon />
                <span>独家配套书籍</span>
            </div>
        </div>
        <div class="books_content">
            <el-carousel
                :interval="5000"
                arrow="always"
                indicator-position="outside"
                height="320px"
            >
                <el-carousel-item v-for="(slide, slideIndex) in bookSlides" :key="slideIndex">
                    <div class="books_slide">
                        <div
                            v-for="book in slide"
                            :key="book.id"
                            class="books_item"
                            @click="openBookModal"
                        >
                            <div class="books_cover">
                                <img
                                    v-if="book.cover"
                                    :src="book.cover"
                                    :alt="book.name"
                                    loading="lazy"
                                >
                            </div>
                            <div class="books_info">
                                <div class="books_name">{{ book.name }}</div>
                                <div class="books_price">
                                    <span class="books_price_current">{{ book.price }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="booksImgBg">
            <img src="@/assets/booksImg.png" alt="">
        </div>
        <!-- 详情弹窗 -->
        <client-only>
            <Teleport to="body">
                <Transition name="book-fade">
                    <div v-if="showBookModal" class="book_modal_mask" @click.self="closeBookModal">
                        <div class="book_modal_content">
                            <img class="qrcode_bg" src="@/assets/buyBooksImg.png" alt="添加助教老师">
                            <div class="book_modal_qrcode">
                                <img src="@/assets/teacherWX.png" alt="微信二维码">
                            </div>
                        </div>
                    </div>
                </Transition>
            </Teleport>
        </client-only>
    </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'

export default defineComponent({
  setup () {
    const books = ref([
        { id: 1, cover: '/images/books/1.webp', name: '超核心词汇', price: '48.00' },
        { id: 2, cover: '/images/books/2.webp', name: '搞定长难句', price: '50.00' },
        { id: 3, cover: '/images/books/3.webp', name: '语法点石成金', price: '49.00' },
        { id: 4, cover: '/images/books/4.webp', name: '解题新途径', price: '48.00' },
        { id: 5, cover: '/images/books/5.webp', name: '真题汇编', price: '50.00' },
        { id: 6, cover: '/images/books/6.webp', name: '英语五步通关', price: '229.00' },
        { id: 7, cover: '/images/books/7.webp', name: '同等学力申硕考试辅导用书临床医学学科综合', price: '159.00' },
        { id: 8, cover: '/images/books/8.webp', name: '教育学原理', price: '57.00' },
        { id: 9, cover: '/images/books/9.webp', name: '中外教育史', price: '59.00' },
        { id: 10, cover: '/images/books/10.webp', name: '教育心理学', price: '61.00' },
        { id: 11, cover: '/images/books/11.webp', name: '教育科学研究方法', price: '57.00' },
        { id: 12, cover: '/images/books/12.webp', name: '同等学力申硕教育学考试辅导用书', price: '199.00' },
        { id: 13, cover: '/images/books/13.webp', name: '同等学力申硕考试辅导用书：法学冲刺60+', price: '169.00' },
        { id: 14, cover: '/images/books/14.webp', name: '申硕论文通关指导', price: '59.00' },
        { id: 15, cover: '/images/books/15.webp', name: '教育学考点批注与避错指南', price: '79.90' },
        { id: 16, cover: '/images/books/16.webp', name: '高频核心词汇', price: '44.00' },
        { id: 17, cover: '/images/books/17.webp', name: '强力突破词汇', price: '47.00' },
        { id: 18, cover: '/images/books/18.webp', name: '闪背暴涨词汇', price: '49.00' },
        { id: 19, cover: '/images/books/19.webp', name: '同力英语词汇备考三部曲', price: '79.90' },
        { id: 20, cover: '/images/books/20.webp', name: '五年真题  三年模拟-教育学', price: '62.00' },
        { id: 21, cover: '/images/books/21.webp', name: '五年真题  三年模拟-工商管理', price: '62.00' },
        { id: 22, cover: '/images/books/22.webp', name: '五年真题  三年模拟-临床医学', price: '62.00' },
        { id: 23, cover: '/images/books/23.webp', name: '政治学全析', price: '129.00' },
        { id: 24, cover: '/images/books/24.webp', name: '中国语言文学高分应试攻略', price: '139.00' },
        { id: 25, cover: '/images/books/25.webp', name: '教育学原理', price: '50.00' },
        { id: 26, cover: '/images/books/26.webp', name: '中国教育史', price: '52.00' },
        { id: 27, cover: '/images/books/27.webp', name: '外国教育史', price: '50.00' },
        { id: 28, cover: '/images/books/28.webp', name: '教育心理学', price: '49.00' },
        { id: 29, cover: '/images/books/29.webp', name: '333教育综合', price: '159.00' },
        { id: 30, cover: '/images/books/30.webp', name: '词根词缀小册子', price: '45.00' },
        { id: 31, cover: '/images/books/31.webp', name: '解密5大题型', price: '47.00' },
        { id: 32, cover: '/images/books/32.webp', name: '考研英语专项知识点精练', price: '54.00' },
        { id: 33, cover: '/images/books/33.webp', name: '英语（二）', price: '193.00' },
        { id: 34, cover: '/images/books/34.webp', name: '疯狂词汇  只背真正要考的', price: '58.90' },
        { id: 35, cover: '/images/books/35.webp', name: '考研政治复习全书', price: '70.00' },
        { id: 36, cover: '/images/books/36.webp', name: '考研政治真题解密', price: '67.00' },
        { id: 37, cover: '/images/books/37.webp', name: '考研政治知识点精练', price: '68.00' },
        { id: 38, cover: '/images/books/38.webp', name: '考研政治高分攻略——基础篇', price: '62.00' },
        { id: 39, cover: '/images/books/39.webp', name: '考研政治高分攻略——题型篇', price: '62.00' },
        { id: 40, cover: '/images/books/40.webp', name: '思想政治理论', price: '199.00' },
        { id: 41, cover: '/images/books/41.webp', name: '管理类联考综合能力逻辑高分攻略', price: '47.50' },
        { id: 42, cover: '/images/books/42.webp', name: '管理类联考综合能力数学高分攻略', price: '47.00' },
        { id: 43, cover: '/images/books/43.webp', name: '管理类联考综合能力写作高分攻略', price: '47.00' },
        { id: 44, cover: '/images/books/44.webp', name: '199管理类联考综合能力', price: '179.00' },
    ])

    const bookSlides = computed(() => {
        const slides = []
        const pageSize = 5
        for (let i = 0; i < books.value.length; i += pageSize) {
            slides.push(books.value.slice(i, i + pageSize))
        }
        return slides
    })
    const showBookModal = ref(false)
    const openBookModal = () => {
        showBookModal.value = true
    }
    const closeBookModal = () => {
        showBookModal.value = false
    }

    return {
        books,
        bookSlides,
        showBookModal,
        openBookModal,
        closeBookModal
    }
  }
})
</script>

<style lang="scss" scoped>
.books_wrapper {
    padding: 25px 0;
}

.books_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
    line-height: 22px;
    color: #333;
}

.books_title_name {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 34px;

    img {
        width: 24px;
        height: 24px;
    }
}

.books_title_more {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: #666;
}

.books_content {
    background: #ffffff;
    border-radius: 16px;
    padding: 30px 10px 10px 10px;
    position: relative;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);

    :deep(.el-carousel__arrow) {
        width: 40px;
        height: 40px;
        background-color: rgba(255, 255, 255, 0.9);
        color: #999;
        border: 1px solid #ebeef5;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        &:hover {
            background-color: #ffffff;
            color: #3d7fff;
        }
    }
    :deep(.el-carousel__arrow) {
        i {
            color: #929292;
            font-size: 16px;
            font-weight: normal;
            transition: transform 0.3s;
        }
        &:hover {
            i {
                color: #333;
                font-weight: bold;
                transform: scale(1.1);
            }
        }
    }

    :deep(.el-carousel__arrow--left) {
        left: 10px;
    }

    :deep(.el-carousel__arrow--right) {
        right: 10px;
    }

    :deep(.el-carousel__indicators) {
        bottom: -25px;

        .el-carousel__indicator {
            .el-carousel__button {
                width: 20px;
                height: 4px;
                border-radius: 2px;
                background-color: #dcdfe6;
            }

            &.is-active .el-carousel__button {
                background-color: #3d7fff;
            }
        }
    }
}

.booksImgBg {
    margin: 40px 0 20px 0;
}

.books_slide {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    padding: 0 60px;
}

.books_item {
    width: 18%;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        transform: translateY(-4px);
    }
}

.books_cover {
    width: 100%;
    height: 240px;
    // background: #f5f7fa;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.books_info {
    padding: 0 5px;
}

.books_name {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #333;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    height: 20px;
}

.books_price {
    margin-bottom: 8px;

    .books_price_current {
        font-size: 18px;
        font-weight: 600;
        color: #f23c3c;
        margin-right: 6px;

        &::before {
            content: '¥';
            font-size: 12px;
            margin-right: 6px;
        }
    }
}

.books_tag {
    display: inline-block;
    padding: 2px 8px;
    background: rgba(61, 127, 255, 0.1);
    color: #3d7fff;
    font-size: 12px;
    border-radius: 10px;
}

// 购买书籍弹窗
.book_modal_mask {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;
}

.book_modal_content {
    position: relative;
    width: 320px;
}

.qrcode_bg {
    display: block;
    width: 100%;
    height: auto;
}

.book_modal_qrcode {
    position: absolute;
    top: 350px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 180px;
    height: auto;
    border-radius: 8px;
}

.book-fade-enter-active,
.book-fade-leave-active {
    transition: opacity 0.3s ease;
}

.book-fade-enter-from,
.book-fade-leave-to {
    opacity: 0;
}

</style>